<template>
  <div class="basic-header">
    <div class="content">
      <button
        v-if="showBackButton"
        class="back-button"
        @click="handleBack"
        type="button"
        aria-label="Volver atrás"
      >
        <span
          class="arrow-icon"
          v-html="require('common/icons/Arrow.svg')"
        ></span>
      </button>
      <span class="header-title">{{ title }}</span>
      <div
        class="logo bb-iconColor"
        v-html="require('assets/icons/bigbox.svg')"
      ></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Component from 'vue-class-component';

  @Component({
    props: {
      title: {
        type: String,
        required: true,
      },
      showBackButton: {
        type: Boolean,
        default: true,
      },
      backRoute: {
        type: [String, Object],
        default: null,
      },
    },
  })
  export default class BasicHeaderComponent extends Vue {
    handleBack() {
      if (this.backRoute) {
        // If a specific route is specified, navigate to it
        this.$router.push(this.backRoute);
      } else {
        // If no specific route is specified, use the default behavior (go back)
        this.$router.go(-1);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .basic-header {
    display: flex;
    padding: 16px;
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    position: sticky;
    top: 0;
    z-index: 10;

    .content {
      max-width: 1280px;
      margin: 0 auto;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header-title {
        font-size: 24px;
        font-weight: 600;
        color: $DARK-GRAY-2;
        margin: 0;
        flex: 1;
        line-height: 1.2;
      }

      .logo {
        ::v-deep svg {
          display: block;
          width: 100%;
          max-width: 70px;
        }
      }

      .back-button {
        display: flex;

        .arrow-icon {
          color: $DARK-GRAY-2;
          max-height: 18px;
          margin-right: 16px;

          & ::v-deep svg {
            height: 18px;
          }
        }
      }
    }
  }
</style>
